module.exports = __webpack_public_path__ + "media/analytics/analytics_peq-37351919.png";